var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHexagonEmpty({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 54,
    viewBox: "0 0 49 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.8875 12.6048L46.8868 12.6044L26.1236 0.923708L46.8875 12.6048ZM46.8875 12.6048C47.8927 13.1682 48.5 14.2033 48.5 15.3189V38.6811C48.5 39.7967 47.8927 40.8318 46.8875 41.3952L46.8868 41.3956L26.1229 53.0767L26.1219 53.0772C25.1257 53.6405 23.8851 53.6416 22.8764 53.0763L2.11319 41.3956L2.1125 41.3952C1.10732 40.8318 0.5 39.7967 0.5 38.6811V15.3189C0.5 14.2033 1.10732 13.1682 2.1125 12.6048L2.11319 12.6044L22.8771 0.923322L22.8781 0.922776M46.8875 12.6048L22.8781 0.922776M22.8781 0.922776C23.874 0.359584 25.1144 0.358384 26.1229 0.923321L22.8781 0.922776Z",
    fill: "white",
    stroke: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagonEmpty);
export default __webpack_public_path__ + "static/media/hexagon_empty.477ee734241444ad455f2e1b223e6d70.svg";
export { ForwardRef as ReactComponent };